module.exports = __webpack_public_path__ + "static/media/sopt1ru.0e162f41.pdf";